import { render } from "./CreateMessagePage.vue?vue&type=template&id=feb40e86"
import script from "./CreateMessagePage.vue?vue&type=script&lang=js"
export * from "./CreateMessagePage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__